import React from 'react';

import OtelIcon from '../../images/icons/otel.svg';

export const OtelLogo = () => {
  return <img height="18" src={OtelIcon} alt="Otel logo" />;
};
